module.exports = __webpack_public_path__ + "static/img/tab-ten.d49d9c23.png";